export default __webpack_public_path__ + "static/media/property_819.78c38d08.png";